export default __webpack_public_path__ + "static/media/funsorat_wheel.abba84d8.png";